import React, { useState, useEffect } from "react";
import { Button, Form, Icon, Message, Container } from "semantic-ui-react";

import { firebaseConnect } from "react-redux-firebase";

import {
  validateEmail,
  errorMsgs,
} from "../../../../commons/functions/formValidations";

import "./styles.css";

const ForgotPassword = ({ firebase }) => {
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isValid, setIsValid] = useState({
    email: { valid: true, error: "" },
  });

  useEffect(() => {
    email.length > 0 && isValid.email.valid
      ? setDisabled(false)
      : setDisabled(true);
  }, [email, isValid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmail(value);
    switch (name) {
      case "email":
        validateEmail(value)
          ? validateForm(name, true, "")
          : value === ""
          ? validateForm(name, false, errorMsgs.required)
          : validateForm(name, false, errorMsgs.email);
        break;
      default:
        break;
    }
  };
  const validateForm = (name, bool, error) => {
    setIsValid((prevState) => ({
      ...prevState,
      [name]: { valid: bool, error },
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");
      setSuccess(false);
      await firebase.auth().sendPasswordResetEmail(email);
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="forgot-password-container">
      <div className="row justify-content-center align-items-center">
        <div className="col-md-6 col-12">
          <Message warning>
            <Icon name="warning circle" />
            Solo podrá recuperar su contraseña si su correo electrónico está en
            nuestros registros.
          </Message>
          <Form
            error={Boolean(error)}
            onSubmit={handleSubmit}
            loading={loading}
            success={success}
          >
            <Message
              success
              icon="check"
              header="¡Éxito!"
              content="Un correo electrónico ha sido enviado. Para poder recuperar su contraseña, siga las intrucciones."
            />
            <Message error header="Oops!" content={error} />
            <Form.Input
              fluid
              icon="envelope"
              iconPosition="left"
              label="Email"
              placeholder="Email"
              name="email"
              onChange={handleChange}
              value={email}
              type="email"
            />
            <p className="signup-input-error">
              {!isValid.email.valid && isValid.email.error}
            </p>
            <Button
              icon="sign in"
              type="submit"
              color="orange"
              content="Reset Password"
              disabled={disabled || loading}
            />
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default firebaseConnect()(ForgotPassword);
